export const asyncSetTimeout = (cb: () => Promise<void>, delay: number) => {
  return new Promise<void>((resolve) => {
    setTimeout(async () => {
      await cb();
      resolve();
    }, delay);
  });
};
